import(/* webpackMode: "eager" */ "/opt/trendrain/trendrain-web/src/app/news/page.tsx");
